module.exports = __webpack_public_path__ + "img/fbcfb91d8ddb6e72931bb6aa3ac565d0.svg";